/** Texts for application-layer messages: errors. */
export const app = {
  en: {
    "err.invalidEmail": "Enter a valid email address",
    "err.passwordLength": "Use at least 10 characters",
    "err.nameLength": "Use 2 to 40 characters for the name",
    "err.ownAccount": "Your own account cannot be changed or deleted here",
    "err.unknownUser": "This user does not exist",
    "err.registrationClosed": "Registration is closed",
    "err.emailExists": "An account with this email already exists",
    "err.badCredentials": "Incorrect email or password",
    "err.currentPasswordWrong": "Current password is incorrect",
    "err.unknownInstrument": "Unknown market",
    "err.vote.targets": "Give one to three targets.",
    "err.vote.price": "Every price must be a positive number.",
    "err.vote.stop": "The stop must lie behind the entry: below it for long, above it for short.",
    "err.vote.order": "Each target must lie further in the trade's direction than the entry and the target before it.",
    "err.vote.far": "The entry is more than {pct} % away from the current price.",
    "err.vote.locked": "Your tip has been entered; its prices are fixed for this round.",
    "err.vote.notYours": "This tip does not exist (any more) or is not yours.",
    "err.vote.unknownTip": "This tip no longer exists.",
    "err.vote.ownTip": "You cannot vote on your own tip.",
    "err.vote.tipFinal": "This tip has been scored — voting on it is over.",
    "err.messengerMissing": "No bot is set up yet — add it first (step 1).",
    "err.vote.off": "The vote is not switched on for you.",
    "err.vote.viewOnly": "You may see the vote, not give tips or vote.",
    "err.messengerToken": "Telegram could not check the token: {message}. Try again in a moment.",
    "err.messenger.format": "No bot token found. It looks like 123456789:AAH… — copy it from @BotFather's reply (the whole message is fine too).",
    "err.messenger.refused": "Telegram does not know this token. Check it is copied completely, or create a new one in @BotFather with /token.",
    "err.messenger.chatGone": "The bot is no longer in this chat — look for the chats again.",
    "err.messenger.chatPrivate": "The tips go to a channel or a group, not to a person's own chat with the bot.",
    "err.messenger.chatRefused": "The bot may not post there: {message}. Add it to the chat as an administrator.",
    "err.instrumentBuiltin": "Built-in markets cannot be removed",
    "err.providerUnavailable": "Market data provider \"{id}\" is not available",
    "err.noSymbolMapping": "{name} has no symbol for provider \"{provider}\"",
    "err.noDataReturned": "No data received for {name}",
    "err.dataProvider": "The data provider could not be reached: {error}",
    "err.noMarketData": "No market data available for {name}",
    "err.invalidValue": "Invalid value for {path}",
    "err.tooBig": "{path} must be at most {max}",
    "err.tooSmall": "{path} must be at least {min}",
    "err.signIn": "Please sign in",
    "err.adminRequired": "Administrator access required",
    "err.domainInvalid": "Not a valid domain (a name like trading.example.com — no IP address, no localhost)",
    "err.domainNone": "No domain set",
    "err.modeUnavailable": "The mode can only be switched on a server set up by the installer",
    "err.modeSwitching": "A switch is already running",
    "dom.problem.noDns": "The name does not resolve yet: set its A record at your domain provider (changes can take a while).",
    "dom.problem.unreachable": "The name resolves, but https:// does not reach this installation: it points to another server, or the certificate could not be fetched yet (try again later).",
    "dom.problem.elsewhere": "The name reaches another installation, not this one.",
    "err.unexpected": "Unexpected server error",
    "err.invalidJson": "Invalid request",
    "err.badTimeframe": "Unsupported timeframe",
    "err.searchTerm": "Enter a search term",
    "err.unknownSetting": "Unknown setting",
  },
  de: {
    "err.invalidEmail": "Bitte eine gültige E-Mail-Adresse eingeben",
    "err.passwordLength": "Mindestens 10 Zeichen verwenden",
    "err.nameLength": "Der Name braucht 2 bis 40 Zeichen",
    "err.ownAccount": "Das eigene Konto kann hier nicht geändert oder gelöscht werden",
    "err.unknownUser": "Diesen Benutzer gibt es nicht",
    "err.registrationClosed": "Die Registrierung ist geschlossen",
    "err.emailExists": "Es gibt bereits ein Konto mit dieser E-Mail-Adresse",
    "err.badCredentials": "E-Mail oder Passwort ist falsch",
    "err.currentPasswordWrong": "Das aktuelle Passwort ist falsch",
    "err.unknownInstrument": "Unbekannter Markt",
    "err.vote.targets": "Gib ein bis drei Ziele an.",
    "err.vote.price": "Jeder Preis muss eine positive Zahl sein.",
    "err.vote.stop": "Der Stop muss hinter dem Einstieg liegen: bei Long darunter, bei Short darüber.",
    "err.vote.order": "Jedes Ziel muss weiter in Trade-Richtung liegen als der Einstieg und das Ziel davor.",
    "err.vote.far": "Der Einstieg liegt mehr als {pct} % vom aktuellen Kurs entfernt.",
    "err.vote.locked": "Dein Tipp ist eingestiegen; seine Preise stehen für diese Runde fest.",
    "err.vote.notYours": "Diesen Tipp gibt es nicht (mehr), oder er ist nicht deiner.",
    "err.vote.unknownTip": "Diesen Tipp gibt es nicht mehr.",
    "err.vote.ownTip": "Über deinen eigenen Tipp kannst du nicht abstimmen.",
    "err.vote.tipFinal": "Dieser Tipp ist ausgewertet – die Abstimmung darüber ist vorbei.",
    "err.messengerMissing": "Noch ist kein Bot eingerichtet – trage ihn zuerst ein (Schritt 1).",
    "err.vote.off": "Das Voting ist für dich nicht freigeschaltet.",
    "err.vote.viewOnly": "Du darfst das Voting ansehen, aber keine Tipps abgeben oder abstimmen.",
    "err.messengerToken": "Telegram konnte den Token nicht prüfen: {message}. Versuche es gleich noch einmal.",
    "err.messenger.format": "Kein Bot-Token gefunden. Er sieht so aus: 123456789:AAH… – kopiere ihn aus der Antwort von @BotFather (die ganze Nachricht geht auch).",
    "err.messenger.refused": "Telegram kennt diesen Token nicht. Prüfe, ob er vollständig kopiert ist, oder erzeuge in @BotFather mit /token einen neuen.",
    "err.messenger.chatGone": "Der Bot ist nicht mehr in diesem Chat – suche die Chats erneut.",
    "err.messenger.chatPrivate": "Die Tipps gehen in einen Kanal oder eine Gruppe, nicht in einen Einzelchat mit dem Bot.",
    "err.messenger.chatRefused": "Der Bot darf dort nicht posten: {message}. Füge ihn dem Chat als Administrator hinzu.",
    "err.instrumentBuiltin": "Vorinstallierte Märkte können nicht entfernt werden",
    "err.providerUnavailable": "Marktdaten-Anbieter „{id}“ ist nicht verfügbar",
    "err.noSymbolMapping": "Für {name} gibt es kein Symbol beim Anbieter „{provider}“",
    "err.noDataReturned": "Keine Daten für {name} erhalten",
    "err.dataProvider": "Der Datenanbieter war nicht erreichbar: {error}",
    "err.noMarketData": "Keine Marktdaten für {name} verfügbar",
    "err.invalidValue": "Ungültiger Wert für {path}",
    "err.tooBig": "{path} darf höchstens {max} sein",
    "err.tooSmall": "{path} muss mindestens {min} sein",
    "err.signIn": "Bitte melde dich an",
    "err.adminRequired": "Administratorrechte erforderlich",
    "err.domainInvalid": "Keine gültige Domain (ein Name wie trading.beispiel.de – keine IP-Adresse, kein localhost)",
    "err.domainNone": "Keine Domain eingetragen",
    "err.modeUnavailable": "Der Modus lässt sich nur auf einem mit dem Installer eingerichteten Server umschalten",
    "err.modeSwitching": "Ein Wechsel läuft bereits",
    "dom.problem.noDns": "Der Name ist noch nicht auflösbar: beim Domain-Anbieter den A-Eintrag setzen (Änderungen brauchen etwas Zeit).",
    "dom.problem.unreachable": "Der Name ist auflösbar, aber https:// erreicht diese Installation nicht: er zeigt auf einen anderen Server, oder das Zertifikat konnte noch nicht geholt werden (später erneut prüfen).",
    "dom.problem.elsewhere": "Der Name erreicht eine andere Installation, nicht diese.",
    "err.unexpected": "Unerwarteter Serverfehler",
    "err.invalidJson": "Ungültige Anfrage",
    "err.badTimeframe": "Nicht unterstützter Zeitrahmen",
    "err.searchTerm": "Bitte einen Suchbegriff eingeben",
    "err.unknownSetting": "Unbekannte Einstellung",
  },
};
